import { render, staticRenderFns } from "./AnnouncementDetails.vue?vue&type=template&id=28690c12&"
import script from "./AnnouncementDetails.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports